<template>
  <div style="padding-bottom: 20px">
    <van-sticky v-if="this.$route.query.type != 0">
      <navbar :title="title" />
    </van-sticky>

    <van-form>
      <van-field v-model="check_status[survey.state]" label="勘察状态" readonly />
      <van-field v-model="survey.survey_code" label="勘察编号" readonly />
      <van-field v-model="survey.client_name" label="客户名称" readonly />
      <van-field v-model="survey.survey_name" label="项目名称" readonly />
      <van-field v-model="survey.led_name" label="屏幕名称" readonly />
      <van-field v-model="survey.user_name" label="创建人" readonly />
      <van-field v-model="survey.date" label="创建时间" readonly />
			<van-field label="导航位置" value="点击获取位置" readonly @click="onloadMap" v-model="mapdata.address" v-if="mapdata.address">
				<template #button>
					<span>
						点击导航
					</span>
				</template>
			</van-field>
      <div class="button-body">
        <van-button type="primary" @click="cancel()">查看记录单</van-button>
        <van-button type="info" @click="edit()" v-if="editButton">修改记录单</van-button>
        <van-button type="info" @click="onloadMap" v-if="delButton != true && mapdata.address">地图导航</van-button>
      </div>
			<div class="schedule" v-if="survey.file_list">
        <p> 附件列表</p>
				<div class="schedule-body">
					<div class="file-body">
						<div class="file-body-item" v-for="(item, index) in JSON.parse(survey.file_list)" :key="index">
							<div class="img-body" v-if="isTypeImage(item.file_type)">
								<van-image width="100" height="100" :src="fileUrl + item.file_id"
									@click="imgLook(fileUrl + item.file_id)" />
							</div>
							<div class="img-body" v-else-if="isTypeMp4(item.file_type)"
								@click="lookVideo(fileUrl + item.file_id)">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">{{ item.file_name }}</div>
							</div>
							<div class="img-body" v-else-if="isType(item.file_type)"
								@click="lookfile(fileUrl + item.file_id)">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">{{ item.file_name }}</div>
							</div>
							<div class="img-body" v-else @click="clickFile">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">
									{{ item.file_name }}.{{ item.file_type }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
    </van-form>
    <van-popup v-model="showPopup" style="width: 100%;height: 80%;" @opened="pdfpanel">
      <div class="m-pdf">
        <div id="pdf-content"></div>
      </div>
    </van-popup>
    <van-popup v-model="popup.survey" position="right" :style="{ width: '100%', height: '90%' }">
      <iframe v-if="popup.survey" ref="myIframe" :src="iframeUrl" id="myIframe" frameborder="0" :key="iframeUrl"
        style="flex: 1; width: 100%; height: 100%; border: none;"></iframe>
    </van-popup>
		<!-- 地图弹出层 -->
			<AmapPicker 
			v-model="showMapPopup" 
			:draggable="false" 
			:isSearch="false"
			:isbutton="false"
			:isNavigation="true"
			:columns="mapdata"/>
  </div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { post } from "@/api/post";
import { Toast } from "vant";
import global_url from "@/utils/global";
import { isImage, isMp4, istype } from "@/utils/tool";
import { ImagePreview } from "vant";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
import IframeMessage from '@/utils/IframeMessage';
import AmapPicker from "@/components/maps/AmapPicker.vue"; // 引入 AddressPicker 组件
// import { Dialog } from 'vant';
// import axios from "axios";
// import { getToken } from "@/utils/auth";

let iframeMessage = null;
export default {
  name: "customer",
  components: {
    navbar,
		AmapPicker 
  },
  data() {
    return {
      title: "勘察详情",
      check_status: ["勘察中", "已派单", "已完成", "已删除", "已作废"],
      order_type: ["渠道批发", "成品制作", "工程安装", "指导安装", "产品借用"],
      popup: {
        select: false,
        survey: false
      },
      form: {
        requestType: "design_data",
        survey_id: this.$route.query.id,
      },
			mapdata: {
				address: "", // 地址输入框
				latitude: 0, // 纬度
				longitude: 0, // 经度
				},
      survey: {},
      showPopup: false,
      delButton: false,
      editButton: false,
      showMapPopup:false,
      iframeUrl: "",
      survey_data: "",
      design_data: "",
      fileUrl: this.findUrl(),
    };
  },
  mounted() {
    this.loadIframeUrl();
    this.getDetails();
  },
  methods: {
    //获取订单详情
    getDetails() {
      post(this.form)
        .then((res) => {
          this.survey = res.obj;
          this.design_data = res.obj.design_data;
          this.survey_data = res.obj.survey_data;
          if (res.obj.state == 0 && res.obj.p) {
            this.delButton = true;
            this.editButton = true;
          }
					if (res.obj.map_data) {
						const map = JSON.parse(res.obj.map_data);
						this.mapdata.latitude = map.latitude;
						this.mapdata.longitude = map.longitude;
						this.mapdata.address = map.address;
					}
        })
        .catch(() => {
          Toast.fail("数据异常");
        });
    },
    loadIframeUrl() {
      const fullUrl = this.GLOBAL.httpURL;
      const url = new URL(fullUrl);
      const protocol = url.protocol; // 获取协议部分 (http: 或 https:)
      const baseUrl = `${protocol}//${url.hostname}${url.port ? ':' + url.port : ''}`; // 包含协议和端口号的完整基础 URL
      this.iframeUrl = `${baseUrl}/survey/questionnaire/readonly??isShowAnswerProgress=false&isShowCountdown=false&isShowAnswerSheet=false&isShowMarkQuestion=false&isShowClassifyAnswerSheet=false&isShowMarkers=false`; // 拼接成新的地址

    },
    cancel() {
      this.popup.survey = true
      if (this.popup.survey) { // 确保弹窗打开时才初始化
        if (iframeMessage) {
          iframeMessage.destroy();
        }
        iframeMessage = new IframeMessage('myIframe');
        if (this.design_data && this.survey_data) {
          let questionnaireData = JSON.parse(this.design_data);
          let data = JSON.parse(this.survey_data);
          iframeMessage.send({
            type: 'setQuestionnaireData',
            data: {
              questionnaireData, data
            }
          });
        }
      }
    },
    edit() {
      this.$router.push({
        path: "/survey",
        query: { id: this.form.survey_id },
      });
    },
    // del(){
    //   Dialog.confirm({
    // 			title: '提示',
    // 			message: '确定作废吗？',
    // 		})
    // 			.then(() => {
    // 				let formData = new FormData();
    // 				formData.append("requestType", "survey_add");
    // 				formData.append("survey_id", this.form.survey_id);
    // 				formData.append("state", 4);
    // 				formData.append("type", 1);
    // 				formData.append("token", getToken());
    // 				const config = {
    // 					headers: {
    // 						"Content-Type": "multipart/form-data"
    // 					}
    // 				};
    // 				axios
    // 					.post(this.GLOBAL.httpURL, formData, config)
    // 					.then((res) => {
    // 						if (res.data.code === 200) {
    //               Toast.success("提交成功!");
    //               this.delButton = false;
    //               this.editButton = false;
    // 							this.getDetails();
    // 						} else {
    // 							Toast.fail("提交失败,请稍后重试!");
    // 						}
    // 					})
    // 					.catch(() => {
    // 						Toast.fail("提交失败,请稍后重试!");
    // 					});
    // 			})
    // },
    pdfpanel() {
      //先实例化
      this.pdfh5 = new Pdfh5("#pdf-content", {
        pdfurl: this.pdfUrl,
        goto: 1,
        lazy: true,
      });
      this.pdfh5.scrollEnable(true);
    },
    lookfile(row) {
      this.showPopup = true;
      this.pdfUrl = row
      // console.log(row);

    },
    isTypeMp4(name) {
      return isMp4(name);
    },
    isTypeImage(name) {
      return isImage(name);
    },
    isType(name) {
      return istype(name);
    },
    findUrl() {
      return global_url.fileUrl;
    },
    imgLook(url) {
      ImagePreview({
        images: [url],
      });
    },
    clickFile() {
      return Toast.fail("暂不支持该文件查看");
    },
		onloadMap() {
			this.showMapPopup = true;
		},
  },
};
</script>

<style lang="scss" scoped>
.button-body {
  padding: 0 15%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.m-pdf {
	// 保证pdf区域铺满整个屏幕
	// 方法1：使用vw和vh视窗单位，1vw=视窗宽度的1%；1vh=视窗高度的1%
	// width: 100vw;
	// height: 100vh;
	// 方法2：使用fixed定位
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
}

.file-body {
	width: calc(100% + 10px);
	padding: 0;
	display: flex;
	flex-wrap: wrap;

	.file-body-item {
		list-style: none;
		flex: 0 0 calc(33.33% - 10px);
		margin-right: 10px;
	}
}

.schedule {
	margin-top: 1px;
	margin-bottom: 12px;
	// padding-left:15px;
	margin-left: 20px;
	margin-right: 20px;

	// overflow: hidden;
	.file-body {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-top: 2px;

		&-item {
			position: relative;
			margin: 0 2px 2px 0;
			cursor: pointer;

			.img-body {
				display: block;
				width: 80px;
				height: 80px;
				overflow: hidden;
				border-radius: 8px;
				box-shadow: #ebedf0 0 4px 12px;
				text-align: center;

				img {
					object-fit: cover;
					display: block;
					width: 100%;
					height: 100%;
				}

				.file-icon {
					position: relative;
					display: inline-block;
					font: normal normal normal 14px/1 "vant-icon";
					font-size: inherit;
					text-rendering: auto;
					-webkit-font-smoothing: antialiased;
					color: #646566;
					font-size: 20px;
					margin-top: 15px;
				}

				.file-name {
					box-sizing: border-box;
					width: 100%;
					margin-top: 4px;
					padding: 0 4px;
					color: #646566;
					font-size: 12px;
					text-align: center;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
				}
			}
		}
	}
}
</style>